var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-magnifier'></i> Browse BL/AWB"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "mx-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pencarian"
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto pr-3 pb-3"
  }, [_c('router-link', {
    attrs: {
      "to": "/rekonmanifes/add"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button",
      "router": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah File")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('th', {
    on: {
      "click": function($event) {
        _vm.sort('NM_PERUSAHAAN')
      }
    }
  }, [_vm._v("Nama Perusahaan "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('no_bl')
      }
    }
  }, [_vm._v("Nomor AWB/BL "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('tgl_bl')
      }
    }
  }, [_vm._v("Tanggal "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('jn_perusahaan')
      }
    }
  }, [_vm._v("Pengirim "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('jn_perusahaan')
      }
    }
  }, [_vm._v("Jenis Dokumen "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th', {
    on: {
      "click": function($event) {
        _vm.sort('wk_kirim')
      }
    }
  }, [_vm._v("Waktu Kirim "), _c('i', {
    staticClass: "fa fa-arrows-v pull-right"
  })]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageOfItems), function(bl) {
    return _c('tr', {
      key: bl.id_rekon_manifes
    }, [_c('td', [_vm._v(_vm._s(bl.NM_PERUSAHAAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.no_bl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.tgl_bl))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.jn_perusahaan == 1 ? 'PJT' : (bl.jn_perusahaan == 2 ? 'Agen Pengangkut' : 'Bea Cukai')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.kd_tujuan == 1 ? 'LDP-KB' : (bl.jn_dokumen == 2 ? 'KB-TLDDP' : '-')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(bl.wk_kirim))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "href": _vm.$http.options.base + bl.file_directory + '/' + bl.file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-3 pb-0 pt-3"
  }, [_c('jw-pagination', {
    attrs: {
      "items": _vm.filteredData
    },
    on: {
      "changePage": _vm.onChangePage
    }
  })], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7358379c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/RekonManifes/browsebl.vue
// module id = 329
// module chunks = 0